import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/*<component-app-price :reduce-price="couponDetail.addPrice" :password="password"></component-app-price>
 * :reduce-price：app直减价
 * :password：商品口令
 * */
import { copy, checkCopyUsable } from '@ykz/ykz-util/platform';
export default {
  name: 'appPrice',
  data: function data() {
    return {
      weChatId: getUrlParams('weChatId') || window.weChatId
    };
  },
  props: ["reducePrice", "password"],
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.appPrice = this;
    console.log("ycf组件初始化：appPrice");
  },
  methods: {
    goAppDownloadPage: function goAppDownloadPage() {
      checkCopyUsable(10) && copy(this.password);
      var that = this;
      this.$parent && this.$parent.generalAnchors("clickGoToDownloadBtn", function () {
        window.location.href = "/front/index/appDownload?weChatId=" + that.weChatId;
      });
    }
  }
};